export const upacaData = {
    my: {
        title: "ဥပစာတန်း",
        subtitle: "သာမဏေကျော်ပထမဆင့် စည်းမျဉ်းအတိုင်း ပိဋကတ်ကို သဒ္ဒါနှင့် အဘိဓမ္မာကို ရောသမမွှေ၍ လေ့လာရသော အတန်း",
        examNote: "ဥပစာတန်း ၌ သဒ္ဒါ ၂-ပုစ္ဆာ၊ သင်္ဂဟ ၂-ပုစ္ဆာ၊ ကျမ်းရင်း ၆-ပုစ္ဆာ ဟူ၍ တစ်ဘာသာ လျှင် ၁၀-ပုစ္ဆာ သာသနာလင်္ကာရစာမေးပွဲ ပထမအဆင့်ပုံစံအတိုင်း မေးရမည်။ အောင်မှတ်မှာ တစ်ဘာသာလျှင် သဒ္ဒါ (၈) မှတ်၊ သင်္ဂဟ (၈) မှတ်၊ ကျမ်းရင်း (၃၀) မှတ် ဖြစ်သည်၊ ၈၀-မှတ်သည် ဂုဏ်ထူးမှတ်၊ ၉၀-မှတ်သည် ဝိသိဋ္ဌဂုဏ်ထူးမှတ် ဖြစ်သည်။",
        subjects: [
            {
                name: "ဝိနည်းမဟာဝါပါဠိတော် (မဟာခန္ဓက)",
            },
            {
                name: "အင်္ဂုတ္တိုရ်ပါဠိတော် (ဧကကနိပါတ်)",
            },
            {
                name: "ဓမ္မပဒအဋ္ဌကထာ (ယမကဝဂ်နှင့် အပ္ပမာဒဝဂ်)",
            }
        ],
        description: [
            "ဥပစာတန်းကား သာမဏေကျော်ပထမဆင့် စည်းမျဉ်းအတိုင်း ပိဋကတ်ကို သဒ္ဒါနှင့် အဘိဓမ္မာကို ရောသမမွှေ၍ လေ့လာရသော အတန်းဖြစ်၏။ ပြဋ္ဌာန်းကျမ်းစာအနည်းနှင့် အများသာ ကွာခြား၏။",
            "ထို့ကြောင့် ဥပစာတန်းကို အောင်မြင်ထားပြီ ဆိုပါက ထိုရဟန်းသာမဏေသည် သာမဏေကျော် ပထမဆင့်ကို အောင်မြင်ရန် ရာခိုင်နှုန်း သေချာသလောက်ဖြစ်နေပြီ ဖြစ်၏။",
            "မူလတန်းနှင့်ဥပစာတန်းကို တက်ရောက်သင်ကြားပြီးသူဖြစ်လျှင် မည်သည့် ပိဋကတ်ကိုမဆို သင်ယူလေ့လာရန် အဆင်သင့် ဖြစ်နေပေပြီ။ ပါဠိစာဟုဆိုလျှင် အကြောက်အလန့်မရှိတော့ပေ။ ရဲရဲရင့်ရင့် ဖတ်ရှုနိုင်နေပြီ ဖြစ်၏။",
            "ထို့ကြောင့် ကျောင်းတွင် ဝါတွင်း လပြည့်, လကွယ်ဥပုသ်နေ့များ၌ ကျင်းပလေ့ရှိသော ပါဠိစကားပြောပွဲများတွင် မူလတန်း၊ ဥပစာတန်းမှ ရှင်သာမဏေများ၊ ရဟန်းတော်များသည်ပင် တက်ရောက်၍ သံဃာပရိသတ် ကိုးရာကျော်ရှေ့တွင် ပါဠိဘာသာဖြင့် ပြောနေကြလေပြီ။"
        ],
    },
    en: {
        title: "Upaca Grade",
        subtitle: "A grade where Pitaka texts are studied with grammar and Abhidhamma following Samanera Kyaw First Level regulations",
        examNote: "In Upaca Grade, there are 2 grammar questions, 2 Sangaha questions, and 6 original text questions, totaling 10 questions per subject following the Thathanalinkara First Level exam format. The pass marks are 8 for grammar, 8 for Sangaha, and 30 for original texts. 80 marks is distinction, and 90 marks is high distinction.",
        subjects: [
            {
                name: "Vinaya Mahavagga Pali (Mahakhandhaka)",
            },
            {
                name: "Anguttara Pali (Ekanipata)",
            },
            {
                name: "Dhammapada Atthakatha (Yamaka and Appamada Vagga)",
            }
        ],
        description: [
            "The Upaca Grade is a level where students study Pitaka texts integrated with grammar and Abhidhamma following Samanera Kyaw First Level regulations. The main difference lies in the volume of prescribed texts.",
            "Therefore, upon completing the Upaca Grade, a monk or novice is almost certain to pass the Samanera Kyaw First Level examination.",
            "After completing both Basic and Upaca grades, one is ready to study any Pitaka text. They no longer fear Pali texts and can read them confidently.",
            "As a result, Basic and Upaca grade students, both monks and novices, participate in Pali speech events held during the Buddhist Lent full moon and new moon days, delivering speeches in Pali language before an audience of over 900 Sangha members."
        ],
    }
};